import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2074Status: 'idle',
    startProcess2074Error: undefined as any,
    loadUserParamsProcess2074Status: 'idle',
    loadUserParamsProcess2074Error: undefined as any,

    process2074List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2074 = createAsyncThunk('process2074Slice/startProcess2074', async ({ process2074 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2074/`,
        prepareData(process2074),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2074Status } = getState().process2074Slice
        return startProcess2074Status !== 'pending'
    }
})

export const loadUserParamsProcess2074 = createAsyncThunk('process2074Slice/loadUserParamsProcess2074', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2074/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2074Status } = getState().process2074Slice
        return loadUserParamsProcess2074Status !== 'pending'
    }
})

const Process2074Slice = createSlice({
    name: 'process2074Slice',
    initialState,
    reducers: {
        resetstartProcess2074: (state) => {
            state.job = undefined
            state.startProcess2074Error = undefined
        },
        resetstartProcess2074Error: (state) => {
            state.startProcess2074Error = undefined
        },
        resetloadUserParamsProcess2074: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2074Error = undefined
        },
        resetloadUserParamsProcess2074Error: (state) => {
            state.loadUserParamsProcess2074Error = undefined
        },
        removeFromProcess2074ListById: (state, action) => {
            state.process2074List = state.process2074List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2074ListByIds: (state, action) => {
            state.process2074List = state.process2074List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2074List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2074Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2074List = []
            state.startProcess2074Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2074.pending, (state) => {
            state.startProcess2074Status = 'pending'
            state.startProcess2074Error = undefined
        })
        builder.addCase(startProcess2074.fulfilled, (state, action) => {
            state.startProcess2074Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2074.rejected, (state, action) => {
            state.startProcess2074Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2074Error = action.error.message
            } else {
                state.startProcess2074Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2074.pending, (state) => {
            state.loadUserParamsProcess2074Status = 'pending'
            state.loadUserParamsProcess2074Error = undefined
        })
        builder.addCase(loadUserParamsProcess2074.fulfilled, (state, action) => {
            state.loadUserParamsProcess2074Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2074.rejected, (state, action) => {
            state.loadUserParamsProcess2074Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2074Error = action.error.message
            } else {
                state.loadUserParamsProcess2074Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2074,
    resetstartProcess2074Error,
    resetloadUserParamsProcess2074,
    resetloadUserParamsProcess2074Error,
    removeFromProcess2074ListById,
    removeFromProcess2074ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2074Slice.actions
export default Process2074Slice.reducer
